import { useEffect } from "react";
import { Redirect } from "react-router-dom";
import { constants } from "utils";
import { useSchoolReportScope } from "./useSchoolReportScope";

const LANDED_KEY = "schoolReportsLanded";

export const hasLandedOnReports = () => {
  try {
    return Boolean(sessionStorage.getItem(LANDED_KEY));
  } catch (_) {
    // No storage means no way to break a redirect loop — skip the redirect.
    return true;
  }
};

const markLandedOnReports = () => {
  try {
    sessionStorage.setItem(LANDED_KEY, "1");
  } catch (_) {
    // Ignore — hasLandedOnReports already skipped the redirect.
  }
};

/**
 * Sends school/district admins to their reports page ONCE per browser
 * session, and renders `children` (the teacher dashboard) in every other
 * case. Reports are the LANDING page, not a wall: after the first redirect
 * an admin who clicks Groups must be able to stay on the dashboard.
 *
 * The landed flag is written in an effect, not during render, so a render
 * React discards (StrictMode, concurrency) can't mark the session as landed
 * without the redirect actually committing.
 */
export const SchoolReportsLanding = ({ children }) => {
  const { scope } = useSchoolReportScope();
  const shouldRedirect = Boolean(scope) && !hasLandedOnReports();

  useEffect(() => {
    if (shouldRedirect) markLandedOnReports();
  }, [shouldRedirect]);

  if (shouldRedirect) return <Redirect to={constants.SCHOOL_REPORTS_PATH} />;
  return children;
};
